import { isRouteErrorResponse, useRouteError } from "react-router";
import { Button, Mark } from "@mashriqain/ui";
import NotFound from "./NotFound";
import styles from "./NotFound.module.css";

/** Last line of defence: shown if a page fails to load or render. */
export function RouteError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFound />;
  return (
    <section className={styles.page}>
      <Mark size={120} className={styles.mark} />
      <p className="eyebrow">Something went wrong</p>
      <h1 className="display">Please try again in a moment.</h1>
      <Button href="/">Reload the site</Button>
    </section>
  );
}
